define('SageDotCom/Components/LottieAnimation',["jquery"], function ($) {
    function LottieAnimation(scope) {
        if (typeof lottie === "undefined") {
            return;
        }

        var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        var lottieEl = scope.querySelector(".lottie-container");
        if (!lottieEl) return;

        var lottiePath = lottieEl.getAttribute("data-path");
        var playBtn = lottieEl.querySelector(".playLottie");
        var stopBtn = lottieEl.querySelector(".stopLottie");
        var finished = false;
        var animation = null;
        var loaded = false;

        // Respect reduced motion settings
        if (prefersReducedMotion) {
            if (playBtn) playBtn.classList.add("finished");
            return;
        }

        function initAnimation() {
            if (loaded) return;
            loaded = true;

            animation = lottie.loadAnimation({
                container: lottieEl.querySelector(".lottie-animation-content") || lottieEl,
                renderer: "svg",
                loop: false,
                autoplay: false,
                path: lottiePath
            });

            bindAnimationEvents();
        }

        function play() {
            if (!animation) return;
            if (finished) {
                if (playBtn) playBtn.classList.remove("finished");
                animation.stop();
            }
            if (playBtn) {
                playBtn.classList.remove("hover");
                playBtn.classList.remove("stopped");
            }
            if (stopBtn) stopBtn.classList.add("hover");
            animation.play();
            finished = false;
        }

        function pause() {
            if (!animation) return;
            if (stopBtn) stopBtn.classList.remove("hover");
            if (playBtn) {
                playBtn.classList.add("hover");
                playBtn.classList.add("stopped");
            }
            animation.pause();
        }

        function bindAnimationEvents() {
            animation.addEventListener("complete", function () {
                if (stopBtn) stopBtn.classList.remove("hover");
                if (playBtn) {
                    playBtn.classList.add("hover");
                    playBtn.classList.add("finished");
                }
                finished = true;
            });

            animation.addEventListener("DOMLoaded", function () {
                if (prefersReducedMotion) {
                    animation.goToAndStop(animation.totalFrames - 1, true);
                    if (playBtn) playBtn.classList.add("finished");
                    finished = true;
                }
            });
        }

        lottieEl.addEventListener("mouseover", function () {
            if (!animation) return;
            if (!animation.isPaused) {
                if (stopBtn) stopBtn.classList.add("hover");
            } else {
                if (playBtn) playBtn.classList.add("hover");
            }
        });

        lottieEl.addEventListener("mouseout", function () {
            if (playBtn) playBtn.classList.remove("hover");
            if (stopBtn) stopBtn.classList.remove("hover");
        });

        lottieEl.addEventListener("click", function (e) {
            if (e.target && e.target.closest(".playLottie")) {
                play();
                if (stopBtn) stopBtn.focus();
            } else if (e.target && e.target.closest(".stopLottie")) {
                pause();
                if (playBtn) playBtn.focus();
            }
        });

        lottieEl.addEventListener("keydown", function (e) {
            if (e.keyCode !== 13) return;
            if (e.target && e.target.closest(".playLottie")) {
                play();
                if (stopBtn) stopBtn.focus();
            } else if (e.target && e.target.closest(".stopLottie")) {
                pause();
                if (playBtn) playBtn.focus();
            }
        });

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.target === lottieEl) {
                    initAnimation();
                    if (animation) animation.play();
                    observer.disconnect();
                }
            });
        }, {
            rootMargin: "200px", // preload before entering viewport
            threshold: 0.25
        });

        observer.observe(lottieEl);

        this.destroy = function () {
            observer.disconnect();
            if (animation) {
                animation.destroy();
            }
            var clone = lottieEl.cloneNode(true);
            lottieEl.parentNode.replaceChild(clone, lottieEl);
        };
    }

    LottieAnimation.init = function init(args) {
        if (args.IsEditorEditing === true) return null;
        return new LottieAnimation(args.scope);
    };

    return LottieAnimation;
});

